import React from 'react';
import { Modal, Form, Input, Select, Button } from 'antd';
import { DataSourceType } from '../../hooks/useInitDataMap';
import { SystemItem } from '../items';

interface DataSourceDetailModalProps {
  visible: boolean;
  onClose: () => void;
  systems: DataSourceType[];
  selectedSystemId: string | null;
  form: any;
  onValuesChange: (changedValues: any, allValues: any) => void;
  onSave: () => void;
  onCancel: () => void;
  hasChanges: boolean;
  onSystemClick: (systemId: string) => void;
  onDeleteSystem: (system: DataSourceType) => void;
  onAddTable: (systemId: string) => void;
  onTableDragStart: (datasourceId: string, tableId: string, e: React.DragEvent) => void;
  onTableClick: (tableId: string) => void;
  handleAddSystem: () => void;
  onDeleteTableClick: (systemId: string, tableId: string) => void;
}

const DataSourceDetailModal: React.FC<DataSourceDetailModalProps> = ({
  visible,
  onClose,
  systems,
  selectedSystemId,
  form,
  onValuesChange,
  onSave,
  onCancel,
  hasChanges,
  onSystemClick,
  onDeleteSystem,
  onAddTable,
  onTableDragStart,
  onTableClick,
  handleAddSystem,
  onDeleteTableClick,
}) => {
  console.log('systems======', systems, 'selectedSystemId', selectedSystemId);
  
  return (
    <Modal
      title="数据源详情"
      open={visible}
      onCancel={onClose}
      width="70vw"
      footer={null}
      centered
      zIndex={999}
      height={'70vh'}
    >
      <div className="flex gap-0 h-[60vh]">
        {/* 左侧数据源列表 */}
          <div 
            className="w-80 overflow-y-auto py-4 bg-white" 
            style={{
              borderRight: '2px solid #ddd'
            }}
          >
          <div className="flex items-center justify-between mb-5 px-4">
            <h3 className="text-lg font-semibold text-[#132347] m-0 mr-3">仓库 | 数据源</h3>
            <Button 
              type="primary" 
              size="small" 
              onClick={handleAddSystem}
              className="h-8 w-8 p-0 flex items-center justify-center" // Tailwind 调整按钮尺寸
            >
              +
            </Button>
          </div>
          <div className="h-[calc(60vh-100px)] overflow-y-auto p-4 bg-white " >
            {systems.map(system => (
              <SystemItem 
                key={system.id}
                system={system}
                onDeleteSystem={onDeleteSystem}
                onAddTable={onAddTable}
                onTableDragStart={onTableDragStart}
                onSystemClick={onSystemClick}
                onTableClick={onTableClick}
                isSelected={selectedSystemId === system.id}
                isShowTable={false}
                onDeleteTableClick={onDeleteTableClick}
              />
            ))}
          </div>
        </div>
        
        {/* 右侧编辑面板 */}
        <div className="flex-1 p-6 overflow-y-visible bg-white flex flex-col justify-center">
          {selectedSystemId ? (
            <>
              {/* 获取当前选中的数据源 */}
              {(() => {
                const currentSystem = systems.find(system => system.id === selectedSystemId);
                
                // 如果数据源类型是 FILES，显示文件数据源的详情
                if (currentSystem && currentSystem.datasourceType === 'FILES') {
                  return (
                    <div 
                      className='p-6 my-2 rounded-md w-[36vw] mx-auto'
                      style={{
                        boxShadow: '0 0px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
                        position: 'relative',
                        zIndex: 1
                      }}
                    >
                      <Form
                      form={form}
                      layout="horizontal"
                      onValuesChange={onValuesChange}
                      labelCol={{ span: 6 }}
                      wrapperCol={{ span: 18 }}
                      className="space-y-4"
                    >
                      <Form.Item
                        name="name"
                        label="数据源名称"
                        rules={[{ required: true, message: '请输入数据源名称' }]}
                      >
                        <Input 
                          placeholder="请输入数据源名称" 
                          className="w-1/3 break-all"
                        />
                      </Form.Item>
                       <Form.Item
                        name="datasourceType"
                        label="数据源类型"
                      >
                        <Input 
                          placeholder="本地节点" 
                          className="w-1/3 break-all"
                          value={'本地节点'}
                          disabled
                        />
                      </Form.Item>
                      {/* <Form.Item
                        name="host"
                        label="数据源地址"
                        rules={[{ required: true, message: '请输入数据源地址' }]}
                      >
                        <Input 
                          placeholder="请输入数据源地址" 
                          className="w-1/3 break-all"
                        />
                      </Form.Item> */}
                    </Form>
                    <div className="mt-6 flex justify-end gap-3">
                      <Button 
                        onClick={onCancel} 
                        disabled={!hasChanges}
                        className="px-4 py-2"
                      >
                        取消
                      </Button>
                      <Button 
                        type="primary" 
                        onClick={onSave}
                        disabled={!hasChanges}
                        className="px-4 py-2"
                      >
                        保存
                      </Button>
                    </div>
                    </div>
                  );
                }
                
                // 否则显示数据库数据源的详情（原有表单）
                return (
                  <div 
                    className='p-6 my-2 rounded-md w-[36vw] mx-auto'
                    style={{
                      boxShadow: '0 0px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
                      position: 'relative',
                      zIndex: 1
                    }}
                  >
                    <Form
                      form={form}
                      layout="horizontal"
                      onValuesChange={onValuesChange}
                      labelCol={{ span: 6 }}
                      wrapperCol={{ span: 18 }}
                      className="space-y-4"
                    >
                      <Form.Item
                        name="name"
                        label="数据源名称"
                        rules={[{ required: true, message: '请输入数据源名称' }]}
                      >
                        <Input 
                          placeholder="请输入数据源名称" 
                          className="w-1/3 break-all"
                        />
                      </Form.Item>
                      <Form.Item
                        name="host"
                        label="数据源地址"
                        rules={[{ required: true, message: '请输入数据源地址' }]}
                      >
                        <Input 
                          placeholder="请输入数据源地址" 
                          className="w-1/3 break-all"
                        />
                      </Form.Item>
                      <Form.Item
                        name="port"
                        label="数据源端口"
                        rules={[{ required: true, message: '请输入数据源端口' }]}
                      >
                        <Input 
                          placeholder="请输入数据源端口" 
                          className="w-1/3 break-all"
                        />
                      </Form.Item>
                      <Form.Item
                        name="username"
                        label="用户名"
                        rules={[{ required: true, message: '请输入用户名' }]}
                      >
                        <Input 
                          placeholder="请输入用户名" 
                          className="w-1/3 break-all"
                        />
                      </Form.Item>
                      <Form.Item
                        name="password"
                        label="密码"
                      >
                        <Input.Password 
                          placeholder="请输入密码" 
                          className="w-1/3 break-all"
                        />
                      </Form.Item>
                      <Form.Item
                        name="databaseType"
                        label="数据库类型"
                        rules={[{ required: true, message: '请选择数据库类型' }]}
                      >
                        <Select 
                          placeholder="请选择数据库类型" 
                          className="!w-1/3 break-all"
                        >
                          <Select.Option value="MySQL">MySQL</Select.Option>
                          <Select.Option value="PostgreSQL">PostgreSQL</Select.Option>
                        </Select>
                      </Form.Item>
                    </Form>
                    <div className="mt-6 flex justify-end gap-3">
                      <Button 
                        onClick={onCancel} 
                        disabled={!hasChanges}
                        className="px-4 py-2"
                      >
                        取消
                      </Button>
                      <Button 
                        type="primary" 
                        onClick={onSave}
                        disabled={!hasChanges}
                        className="px-4 py-2"
                      >
                        保存
                      </Button>
                    </div>
                  </div>
                );
              })()}
            </>
          ) : (
            <div className="flex items-center justify-center h-full text-gray-500 text-lg">
              请选择一个数据源查看详情
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default DataSourceDetailModal;